import { Icon20Cancel } from '@vkontakte/icons';
import { Spacing, Text } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './AsidePromoModal.css';
import { IAsidePromoModalProps } from './AsidePromoModal.types';

export const AsidePromoModal = memo<IAsidePromoModalProps>(({ title, text, imageUrl, buttonText, href, onShow, onClick, onClose }) => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        onShow?.();
    }, []);

    const handleClick = useCallback(() => {
        setShow(false);
        onClick?.();
    }, [onClick, setShow]);

    const handleClose = useCallback(() => {
        setShow(false);
        onClose?.();
    }, [onClose, setShow]);

    if (!show) {
        return null;
    }

    return (
        <div className={styles.root}>
            <div className={styles.imageWrapper}>
                <img className={styles.image} src={imageUrl} alt="Cover image" />
            </div>
            <div className={styles.content}>
                <Text className={styles.title}>{title}</Text>
                <Spacing size={8} />
                <Text className={styles.text}>{text}</Text>
                <Spacing size={20} />
                <Button className={styles.button} href={href} theme="vk" primary target="_blank" onClick={handleClick}>
                    {buttonText}
                </Button>
            </div>
            <div className={styles.close} onClick={handleClose}>
                <Icon20Cancel width={18} height={18} />
            </div>
        </div>
    );
});

AsidePromoModal.displayName = 'AsidePromoModal';
